import React from 'react'
import { Link } from 'react-router-dom'

function AppLogo() {
  return (
    <Link to={'/'}>
      {/* <img src='' alt='logo' width={'30px'} /> */}
      Artichoke App
    </Link>
  )
}

export default AppLogo
